window.reactionCancelFormatter = function(value, row) {
    let html = '';
    if (row.can_cancel === 0) {
        return html;
    }
    html += '<a class="button-cancel button btn btn-danger btn-sm me-3" data-id="'+row.id+'">';
    html += '<i class="fal fa-times"></i>';
    html += __('Annuleren');
    html += '</a>';
    return html;
};
